export default "__VITE_ASSET__e5875d72__"